
import ProfileSidebar from './components/ProfileSidebar';
import OrderHistory from './components/OrderHistory';
import { Order } from '../../types/Order.interface';

interface Props {
  orders: Order[];
  getOrders: (page: number, limit: number) => void;
  formatDate: (date: string) => string;
  getPaymentStatus: (order: Order) => string;
  copyOrder: (orderId: number) => void;
  isLoading: boolean;
}

const ProfileOrders = ({ orders, getOrders, formatDate, getPaymentStatus, copyOrder, isLoading }: Props) => {
  
  return (
      <div className="container mx-auto flex-1 py-8 px-4 md:px-6">
        <h1 className="mb-6 text-2xl font-bold font-sans">Мои заказы</h1>
        
        <div className="flex flex-col space-y-6 md:flex-row md:space-x-6 md:space-y-0">
          <div className="w-full md:w-1/4">
            <ProfileSidebar />
          </div>
          
          <div className="w-full md:w-3/4">
            <OrderHistory 
              orders={orders} 
              getOrders={getOrders} 
              formatDate={formatDate} 
              getPaymentStatus={getPaymentStatus} 
              copyOrder={copyOrder} 
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
  );
};

export default ProfileOrders;
